export default __webpack_public_path__ + "static/media/tigerbox_touch_green.a709997b.png";